import { useTranslation } from 'react-i18next'
import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import RadioBlock from '../../../../../../../components/Form/RadioBlock'
import CategoriesSection from '../../../../../reusableFormFields/CategoriesSection'
import KeywordsSection from '../../../../../reusableFormFields/KeywordsSection'
import KeywordExclusionListsSection from '../../../../../reusableFormFields/KeywordExclusionListsSection'

import { clearGetDv360NegativeKeywordLists } from '../../../../../../../modules/actions/dv360Constants'
import { dv360NegativeKeywordListsWasLoadedSelector } from '../../../../../../../modules/selectors/dv360Constants'

import { TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS, YES_USING_PRE_SAVED_KEYWORD_EXCLUSION_LISTS } from '../../fields'
import { OPTION_NO, OPTION_YES } from '../../../../../../../constants/forms'

const CategoriesAndKeywordsStep = ({ formik, handleStepChange }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const dv360NegativeKeywordListsWasLoaded = useSelector(dv360NegativeKeywordListsWasLoadedSelector)

  const { values, setFieldValue } = formik

  const handleContinue = useCallback(() => {
    handleStepChange()
  }, [handleStepChange])

  useEffect(() => {
    if (dv360NegativeKeywordListsWasLoaded) {
      return () => {
        dispatch(clearGetDv360NegativeKeywordLists())
      }
    }
  }, [dispatch, dv360NegativeKeywordListsWasLoaded])

  return (
    <Step stepTitle="Would you like to target specific categories or keywords?" handleContinue={handleContinue}>
      <RadioBlock
        setFieldValue={setFieldValue}
        id={TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS + OPTION_NO}
        name={TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS}
        value={OPTION_NO}
        selectedValue={values[TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS]}
        label={t('No')}
      />
      <RadioBlock
        setFieldValue={setFieldValue}
        id={TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS + YES_USING_PRE_SAVED_KEYWORD_EXCLUSION_LISTS}
        name={TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS}
        value={YES_USING_PRE_SAVED_KEYWORD_EXCLUSION_LISTS}
        selectedValue={values[TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS]}
        label={t('Yes, using pre-saved keyword exclusion Lists')}
      >
        <CategoriesSection formik={formik} />
        <KeywordExclusionListsSection formik={formik} />
      </RadioBlock>
      <RadioBlock
        setFieldValue={setFieldValue}
        id={TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS + OPTION_YES}
        name={TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS}
        value={OPTION_YES}
        selectedValue={values[TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS]}
        label={t('Yes, manually entering the keywords')}
      >
        <CategoriesSection formik={formik} />
        <KeywordsSection formik={formik} />
      </RadioBlock>
    </Step>
  )
}

export default CategoriesAndKeywordsStep
